module.exports = __webpack_public_path__ + "static/assets/21c9cd5e177405e872a43c01da6a18ab.svg";